import { render, staticRenderFns } from "./AddLangModal.vue?vue&type=template&id=49b6eb08"
import script from "./AddLangModal.vue?vue&type=script&lang=js"
export * from "./AddLangModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports